import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const importDataReducer = createReducer(initialState, {
  FETCH_IMPORT_DATA_REQUEST: (state) => {
    state.loading = true;
    state.error = null;
  },
  FETCH_IMPORT_DATA_SUCCESS: (state, action) => {
    state.loading = false;
    state.data = action.payload; 
    state.error = null;
  },
  FETCH_IMPORT_DATA_FAILURE: (state, action) => {
    state.loading = false;
    state.data = null;
    state.error = action.payload;
  },
});

export default importDataReducer;